function o(r, e) {
  var a = e && e.cache ? e.cache : g, t = e && e.serializer ? e.serializer : v, c = e && e.strategy ? e.strategy : h;
  return c(r, {
    cache: a,
    serializer: t
  });
}
function l(r) {
  return r == null || typeof r == "number" || typeof r == "boolean";
}
function s(r, e, a, t) {
  var c = l(t) ? t : a(t), i = e.get(c);
  return typeof i > "u" && (i = r.call(this, t), e.set(c, i)), i;
}
function u(r, e, a) {
  var t = Array.prototype.slice.call(arguments, 3), c = a(t), i = e.get(c);
  return typeof i > "u" && (i = r.apply(this, t), e.set(c, i)), i;
}
function f(r, e, a, t, c) {
  return a.bind(e, r, t, c);
}
function h(r, e) {
  var a = r.length === 1 ? s : u;
  return f(r, this, a, e.cache.create(), e.serializer);
}
function y(r, e) {
  return f(r, this, u, e.cache.create(), e.serializer);
}
var v = function() {
  return JSON.stringify(arguments);
};
function n() {
  this.cache = /* @__PURE__ */ Object.create(null);
}
n.prototype.get = function(r) {
  return this.cache[r];
};
n.prototype.set = function(r, e) {
  this.cache[r] = e;
};
var g = {
  create: function() {
    return new n();
  }
}, d = {
  variadic: y
};
export {
  o as memoize,
  d as strategies
};
